export const getFormattedTime = (initialDate: Date, timeAgo?: number) => {
  const dateXago = new Date(timeAgo ? initialDate.getTime() - timeAgo : initialDate.getTime())
  const year = dateXago.getFullYear()
  const month = dateXago.getMonth().toString().length === 1 ? `0${dateXago.getMonth() + 1}` : dateXago.getMonth() + 1
  const day = dateXago.getDate().toString().length === 1 ? `0${dateXago.getDate()}` : dateXago.getDate()
  return `${year}-${month}-${day}`
}
